import { render } from "./OrganisationRegistrationHeader.vue?vue&type=template&id=08843a21&scoped=true"
const script = {}

import "../../components/Header/RegistrationHeader.scss?vue&type=style&index=0&id=08843a21&lang=scss&scoped=true&external"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-08843a21"]])

export default __exports__